import { getAction, deleteAction, putAction, postAction, httpAction } from '@/api/manage'
import Vue from 'vue'
import {UI_CACHE_DB_DICT_DATA } from "@/store/mutation-types"

const editEnterprise= (params)=>putAction("/ebid-ce/enterprise/editEnterpriseInfo",params);
const getEnterprise= (params)=>getAction("/ebid-ce/enterprise/getEnterpriseInfo",params);
//用户管理
const addEnterpriseUser = (params)=>postAction("/sys/user/addEnterpriseUser",params);
//用户编辑
const editEnterpriseUser = (params)=>postAction("/sys/user/editEnterpriseUser",params);

export {
  editEnterprise,
  getEnterprise,
  addEnterpriseUser,
  editEnterpriseUser,
}